import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AlarmsService {

  source = null;
  active = null;

  setSource(source: string, active: number) {
    this.source = source;
    this.active = active;
  }

  isStarted(): boolean {
    if (this.source && this.active) {
      return true;
    }
    return false;
  }

  getValues() {
    return {
      source: this.source,
      active: this.active
    };
  }

  cleanValues() {
    this.source = null;
    this.active = null;
  }

}
